import { render, staticRenderFns } from "./CompletedAction.vue?vue&type=template&id=8aa80dc8"
import script from "./CompletedAction.vue?vue&type=script&lang=js"
export * from "./CompletedAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports